import { inject, observer } from "mobx-react";

import { analyticeEvent, baerminUseYn, baeminUsePosNo, kdsSetYn } from "utils/Utils";
import { fn_currOrderType } from "function/FnBodyOrder";
import { fn_bridge_pos_order_list } from "function/FnPosBridge";

const OrderSearchTopView = ({ rootStore }: any) => {
  const { settingStore, layerStore } = rootStore;
  const refundType =
    settingStore.getPayFreeType.paymentUseYn === "2" &&
    (settingStore.getYgyUseStatus === "Y" ||
      (baerminUseYn(rootStore) && (baeminUsePosNo(rootStore) || settingStore.getMainPosType === "Y"))) &&
    layerStore.getReturnFailBtn;

  return (
    <div
      className={
        "order_top_content " + (rootStore.settingStore.getOrderViewType === "card" ? "order_top_content_card" : "")
      }
    >
      <div className="main_top">
        <div
          className={
            "orderCnt" +
            (kdsSetYn(rootStore) ? " default" : " kiosk") +
            (refundType ? " return" : "") +
            (rootStore.settingStore.getKioskOrderState === "all" ? " on" : "")
          }
          onClick={() => {
            analyticeEvent("DashboardTab", "dashboardTabAllStatus Button", "Button");
            fn_currOrderType(rootStore, "all");
            rootStore.settingStore.setKioskOrderState("all");
          }}
        >
          {`전체 ${
            rootStore.settingStore.getManagerSetting?.orderEnd == "Y"
              ? rootStore.searchStore.getEndOrderTypeObj.all
              : rootStore.searchStore.getOrderTypeObjCount("all")
          }`}
        </div>
        <div
          className={
            "orderCnt" +
            (kdsSetYn(rootStore) ? " default" : " kiosk") +
            (refundType ? " return" : "") +
            (rootStore.settingStore.getKioskOrderState == "delivery" ? " on" : "")
          }
          onClick={() => {
            analyticeEvent("DashboardTab", "dashboardTabDelivery Button", "Button");
            fn_currOrderType(rootStore, "delivery");
            rootStore.settingStore.setKioskOrderState("delivery");
          }}
        >
          {`배달 ${
            rootStore.settingStore.getManagerSetting?.orderEnd == "Y"
              ? rootStore.searchStore.getEndOrderTypeObj.delivery
              : rootStore.searchStore.getOrderTypeObjCount("delivery")
          }`}
        </div>
        <div
          className={
            "orderCnt" +
            (kdsSetYn(rootStore) ? " default" : " kiosk") +
            (refundType ? " return" : "") +
            (rootStore.settingStore.getKioskOrderState == "pickTable" ? " on" : "")
          }
          onClick={() => {
            analyticeEvent("DashboardTab", "dashboardTabTakeoutTable Button", "Button");
            fn_currOrderType(rootStore, "pickupAndTable");
            rootStore.settingStore.setKioskOrderState("pickTable");
          }}
        >
          {`포장·매장 ${
            rootStore.settingStore.getManagerSetting?.orderEnd == "Y"
              ? rootStore.searchStore.getEndOrderTypeObj.pickupAndTable
              : rootStore.searchStore.getOrderTypeObjCount("pickupAndTable")
          }`}
        </div>
        {kdsSetYn(rootStore) && (
          <div
            className={
              "orderCnt" +
              (kdsSetYn(rootStore) ? " default" : " kiosk") +
              (refundType ? " return" : "") +
              (rootStore.settingStore.getKioskOrderState == "posOrder" ? " on" : "")
            }
            onClick={() => {
              analyticeEvent("DashboardTab", "dashboardTabAtStore Button", "Button");
              rootStore.settingStore.setKioskOrderState("posOrder");
              rootStore.orderStore.setInitPage();
              fn_bridge_pos_order_list(rootStore);
            }}
          >
            현장 주문만 보기
          </div>
        )}
        {
          //메인포스 & 배달매니저 요금
          refundType && (
            <div>
              <span className="bar3"></span>
              <div className="refund" onClick={() => rootStore.layerStore.setReturnFailView(true)}></div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(OrderSearchTopView));
